import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}

import { AssetManagementPlan } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffLifeCycleCostModelling',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.life_cycle_costs ?? '',
      "diff-value": _ctx.diffPlan?.life_cycle_costs,
      label: "7.1 Life Cycle Costs",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.replacement_value ?? '',
      "diff-value": _ctx.diffPlan?.replacement_value,
      label: "7.1.1 Replacement Value",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.budgets ?? '',
      "diff-value": _ctx.diffPlan?.budgets,
      label: "7.2 Budgets",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.sustaining_capital_budget ?? '',
      "diff-value": _ctx.diffPlan?.sustaining_capital_budget,
      label: "7.2.1 Sustaining Capital Budget",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.capital_projects_budget ?? '',
      "diff-value": _ctx.diffPlan?.capital_projects_budget,
      label: "7.2.2 Capital Projects Budget",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.life_cycle_cost_model ?? '',
      "diff-value": _ctx.diffPlan?.life_cycle_cost_model,
      label: "7.3 Life Cycle Cost Model",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.end_of_life ?? '',
      "diff-value": _ctx.diffPlan?.end_of_life,
      label: "7.4 End Of Life",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"])
  ]))
}
}

})